import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var LibraryFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M21.854 1.18a1.375 1.375 0 0 0-2.46 1.23l20.63 41.25a1.376 1.376 0 0 0 2.46-1.23L21.854 1.18ZM2.744.42c.76 0 1.376.616 1.376 1.375v41.25a1.375 1.375 0 0 1-2.75 0V1.795c0-.76.615-1.375 1.374-1.375ZM12.372.42c.76 0 1.375.616 1.375 1.375v41.25a1.375 1.375 0 0 1-2.75 0V1.795c0-.76.615-1.375 1.375-1.375Z"
  }));
});
LibraryFill.displayName = 'LibraryFill';
LibraryFill.defaultProps = {
  'aria-label': 'LibraryFill'
};
export default LibraryFill;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/LibraryFill.js
// module id = 3197
// module chunks = 11